(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.video-reel').forEach(reel => {
  let video = reel.querySelector('video');
  let button = reel.querySelector('.mute-button');

  if (!video) return;

  video.muted = true;
  video.playsInline = true;
  video.autoplay = true;
  video.loop = true;

  button.addEventListener("click", (e) => {
    e.stopPropagation();
    video.muted = !video.muted;
    if (video.muted) {
      button.innerHTML = `<svg viewBox="0 0 24 24"><path fill="white" d="M16.5 12L19 14.5L20.5 13L18 10.5L20.5 8L19 6.5L16.5 9L14 6.5V17.5L16.5 15L19 17.5L20.5 16L18 13.5L20.5 11L19 9.5L16.5 12Z"></path></svg>`;
    } else {
      button.innerHTML = `<svg viewBox="0 0 24 24"><path fill="white" d="M7 9v6h4l5 5V4l-5 5H7z"></path></svg>`;
      video.play().catch(()=>{});
    }
  });
});

/* --- Auto play only active video (like insta) --- */
const videos = document.querySelectorAll('.video-reel video');
let currentActive = null;
const thresholds = [];
for (let i = 0; i <= 1.0; i += 0.05) thresholds.push(i);

const observer = new IntersectionObserver((entries) => {
  let best = null, bestRatio = 0;
  entries.forEach(entry => {
    if (entry.intersectionRatio > bestRatio) {
      bestRatio = entry.intersectionRatio;
      best = entry.target;
    }
  });
  if (!best) return;

  if (bestRatio >= 0.6 && currentActive !== best) {
    if (currentActive && currentActive !== best) currentActive.pause();
    best.play().catch(()=>{});
    currentActive = best;
  }
}, { threshold: thresholds });

videos.forEach(v => observer.observe(v));

  } catch(e) { console.error(e); }
})();
})();
